import * as core from '../../../../../../../core'
import * as stakeholderEngagementNeeded from '../stakeholder-engagement-needed'

export const RESOURCE = {
  payload: {
    description: 'Standard Group Engagement',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderEngagementNeeded.RESOURCE.payload.partialId,
    }),
    id: 'Standard Group Engagement',
    name: 'Standard Group Engagement',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
